import { render, staticRenderFns } from "./freeJobList.vue?vue&type=template&id=9976a0b8"
import script from "./freeJobList.vue?vue&type=script&lang=js"
export * from "./freeJobList.vue?vue&type=script&lang=js"
import style0 from "./freeJobList.vue?vue&type=style&index=0&id=9976a0b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports